import { Box, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React, { useState } from 'react';
import axiosService from 'utils/axios';
import { Location } from 'types/entities/types';
import ModalPopup from '../../../components/Modal/ModalPopup';

interface Props {
  location?: Location;
  locationName?: string;
  onSave: (location: Location) => void;
  modalTitle: string;
  isModalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

interface LocationCreateUpdateError {
  error: string;
}

export default function AddOrEditLocation(props: Props) {
  const { location, locationName = '', onSave, modalTitle, isModalOpen, setModalOpen } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<LocationCreateUpdateError | null>();

  const [nameInput, setNameInput] = useState(location?.name || locationName);
  const [notesInput, setNotesInput] = useState(location?.notes || '');

  const handleSubmit = () => {
    setLoading(true);
    const data = {
      name: nameInput,
      notes: notesInput,
    };
    if (location) {
      // Update existing location
      axiosService
        .patch(`/entities/location/${location.id}/`, data)
        .then(locationData => {
          setLoading(false);
          setError(null);
          onSave(locationData.data);
        })
        .catch(err => {
          setLoading(false);
          setError(err.response.data || {});
        });
    } else {
      // Create new location
      axiosService
        .post('/entities/location/', data)
        .then(locationData => {
          setLoading(false);
          setError(null);
          onSave(locationData.data);
        })
        .catch(err => {
          setLoading(false);
          setError(err.response.data || {});
        });
    }
  };

  return (
    <ModalPopup
      title={modalTitle}
      open={isModalOpen}
      onClose={() => setModalOpen(false)}
      actionButtons={
        <LoadingButton
          loading={loading}
          onClick={handleSubmit}
          type="submit"
          fullWidth
          variant="contained"
          disabled={!nameInput}
        >
          {location ? 'Edit location' : 'Create location'}
        </LoadingButton>
      }
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ width: '100%', mt: 1 }}>
          {error ? <Typography>{error.error}</Typography> : null}
          <TextField
            fullWidth
            autoFocus
            required
            margin="normal"
            id="name"
            label="Name"
            value={nameInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNameInput(event.target.value);
            }}
          />
          <TextField
            fullWidth
            minRows={5}
            multiline
            margin="normal"
            id="notes"
            label="Notes"
            value={notesInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNotesInput(event.target.value);
            }}
          />
        </Box>
      </Box>
    </ModalPopup>
  );
}
